import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import ReduxToastr from 'react-redux-toastr';
import { pdfjs } from 'react-pdf';
import HashLoader from 'react-spinners/HashLoader';

//localization
import '../src/_translations/i18next';

//redux store
import { store } from './redux/store';

//routing
import Routes from './routes';

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.js',
//   import.meta.url
// ).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Suspense
          fallback={
            <>
              <div className="loading-screen">
                <HashLoader color="#ea4433" />
              </div>
            </>
          }
        >
          <ReduxToastr
            timeOut={4000}
            newestOnTop={false}
            preventDuplicates
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            progressBar
            closeOnToastrClick
          />
          <Routes />
        </Suspense>
      </Router>
    </Provider>
  );
}

export default App;
